import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, Router } from '@angular/router';
import { ToasterService } from '../../shared/services/toaster.service';
import { PermissionService } from '../services/permission.service';

@Injectable({
  providedIn: 'root',
})
export class PermissionGuard implements CanActivate, CanActivateChild {
  constructor(
    private permissionService: PermissionService,
    private router: Router,
    private toaster: ToasterService,
  ) {}

  async canActivate(route: ActivatedRouteSnapshot): Promise<boolean> {
    await this.permissionService.ensurePermissionsLoaded();
    return this.checkPermissions(route);
  }

  async canActivateChild(route: ActivatedRouteSnapshot): Promise<boolean> {
    await this.permissionService.ensurePermissionsLoaded();
    return this.checkPermissions(route);
  }

  private checkPermissions(route: ActivatedRouteSnapshot): boolean {
    const requiredPermissions: string[] = route.data?.['permissions'] || [];
    const requireAll: boolean = (route.data?.['requireAll'] ?? route.parent?.data?.['requireAll'] ?? false) as boolean;

    if (requiredPermissions.length === 0) {
      return true;
    }

    const hasPermission = requireAll
      ? requiredPermissions.every((permission) => this.permissionService.hasPermission(permission))
      : requiredPermissions.some((permission) => this.permissionService.hasPermission(permission));

    if (!hasPermission) {
      this.toaster.clientError('You do not have permission to access this page.', 403);
      this.router.navigate(['/dashboard']);
      return false;
    }

    return true;
  }
}
